import { useQuery } from '@apollo/client';
import {
    TransactionEntryCategoriesForIdsDocument,
    TransactionEntryCategoryFieldsFragment,
    TransactionEntryRuleFieldsFragment,
} from '../../../graphql/generated';
import { getIsValidUuid } from '../../../util/strings';

// Fetch categories for all categoryIds in all rule's changesets and return a map of category id --> category
export const useCategoriesMap = (
    rules: Pick<
        TransactionEntryRuleFieldsFragment,
        'conditions' | 'changeset'
    >[]
) => {
    const conditionCategoryIds = rules.flatMap((rule) =>
        rule.conditions
            .filter(
                (condition) =>
                    condition.field === 'categoryId' &&
                    getIsValidUuid(condition.value)
            )
            .map((condition) => condition.value as string)
    );

    const changeCategoryIds = rules.flatMap((rule) =>
        rule.changeset
            .filter(
                (change) =>
                    change.field === 'categoryId' &&
                    getIsValidUuid(change.value)
            )
            .map((change) => change.value as string)
    );

    const categoryIds = new Set([
        ...conditionCategoryIds,
        ...changeCategoryIds,
    ]);

    const { data: categoriesData, loading: categoriesLoading } = useQuery(
        TransactionEntryCategoriesForIdsDocument,
        {
            variables: {
                ids: categoryIds.size ? Array.from(categoryIds).sort() : [],
            },
        }
    );

    const categoriesMap = categoriesData?.transactionEntryCategories
        ? categoriesData.transactionEntryCategories.reduce(
              (acc, category) => {
                  acc[category.id] = category;
                  return acc;
              },
              {} as Record<string, TransactionEntryCategoryFieldsFragment>
          )
        : {};

    return { categoriesLoading, categoriesMap };
};
